import React from 'react';
import { formatCurrency } from '@avila-tek/ui/src';
import { Product, Variant } from '../../../../models';
import fallbackImg from '../../../../public/images/product-card-fallback.png';

interface ProductItemCardProps {
  product: Product;
  variant: Variant;
}

function ProductItemCard({ product, variant }: ProductItemCardProps) {
  const variantTitle = `${variant?.option?.option1 ?? ''} ${
    variant?.option?.option2 ?? ''
  } ${variant?.option?.option3 ?? ''}`;

  return (
    <div className="w-full flex flex-col items-center sm:items-start sm:flex-row border border-system-500 p-3 rounded-lg my-5  shadow">
      <div className="h-full">
        <img
          src={
            variant.photos.length > 0 ? variant.photos[0].src : fallbackImg.src
          }
          className="object-contain h-full w-44 rounded-lg"
          alt="product"
        />
      </div>
      <div className="flex flex-col sm:pl-5">
        <span className="text-text-black text-lg font-semibold">
          {product.title}
        </span>
        <span className="text-neutral-500">{variantTitle}</span>
      </div>
      <div className="ml-auto">
        <span className="text-purple-300 text-lg font-semibold">
          ${formatCurrency(variant.price)}
        </span>
      </div>
    </div>
  );
}

export default ProductItemCard;
